import { render, staticRenderFns } from "./Trunk.vue?vue&type=template&id=52d0be2a"
import script from "./Trunk.vue?vue&type=script&lang=js"
export * from "./Trunk.vue?vue&type=script&lang=js"
import style0 from "./Trunk.vue?vue&type=style&index=0&id=52d0be2a&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports